export default "__VITE_ASSET__BxIwuSTb__"